<form id="login_form" class="example-container" [formGroup]="form" (ngSubmit)="login()">
  <a class="logo-container" [routerLink]="['/']">
    <img src="/assets/images/logo.png" />
  </a>

  <span>
    <h1>{{ 'LOGIN_signin' | translate }}</h1>
  </span>

  <div class="central-container">
    <div class="input-container">
      <ui-form-input-text [componentId]="'AT_loginUserName'" [label]="'LOGIN_userName' | translate" [form]="form" [controlName]="'userName'"></ui-form-input-text>
    </div>

    <div class="input-container">
      <ui-form-input-password [componentId]="'AT_loginPassword'" [label]="'LOGIN_password' | translate" [form]="form" [controlName]="'password'"></ui-form-input-password>
    </div>

    <div class="forgot-password-container">
      <a id="AT_forgotPassword" [routerLink]="['../require-password-change']">{{ 'LOGIN_forgotPassword' | translate }}</a>
    </div>
  </div>

  <div class="login-input-group">
    <ui-async-button
      class="login-input-button"
      inputClass="full-width flex p-justify-center"
      [inputState]="stateLoginBtn"
      [rounded]="true"
      [type]="'submit'"
      [asyncButton]="true"
      [buttonClassByType]="ASYNC_BUTTON_CLASS_TYPES.PRIMARY"
      [size]="'lg'"
      [label]="('log_in' | translate) + ' con Tasafy'"
      componentId="AT_log_in"
      [loadingLabel]="'logging_in' | translate"
      (clickEvent)="login()"
    />
    <ui-async-button
      class="login-input-button"
      inputClass="full-width flex p-justify-center"
      [inputState]="stateLoginBtn"
      [rounded]="true"
      [type]="'submit'"
      [asyncButton]="true"
      [buttonClassByType]="ASYNC_BUTTON_CLASS_TYPES.SECONDARY"
      [size]="'lg'"
      [label]="('log_in' | translate) + ' con Microsoft'"
      componentId="AT_log_in_microsoft"
      [loadingLabel]="'logging_in' | translate"
      (clickEvent)="loginMicrosoft()"
      [icon]="faMicrosoft"
    />
  </div>
</form>
